export enum Auth0ErrorCodes {
  AccessDenied = 'access_denied',
  InvalidUserPassword = 'invalid_user_password',
  TooManyAttempts = 'too_many_attempts',
  UserIsBlocked = 'unauthorized',
  UserAlreadyExists = 'user_exists',
  InvalidSignupPassword = 'invalid_password',
  LoginRequired = 'login_required'
}
